import { observer } from "mobx-react-lite";

import {
  BaseDetailedWorkoutItemGroup,
  type WorkoutItemGroupProps,
} from "./BaseDetailedWorkoutItemGroup";

export const SupersetDetailedWorkoutItemGroup = observer(
  function SupersetDetailedWorkoutItemGroup(props: WorkoutItemGroupProps) {
    return (
      <BaseDetailedWorkoutItemGroup
        {...props}
        className="gap-1"
        contentClassName="gap-0 pt-2 [&>div:last-child]:pt-2"
      />
    );
  },
);
